import { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { eventGET, eventGET_ID, eventPATCH } from '../EventApi';
import { participantsDELETE, participantsPATCH, participantsPOST } from '../ParticipantsApi';



const DiscoverEvents = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState('all'); // default


  const [isParticipant, setIsParticipant] = useState(null); // default
  const [isApproved, setisApproved] = useState(null); // default
  const [isOrganizer, setIsOrganizer] = useState(null); // default

  const fetchEvents = async () => {
    try {
      const data = await eventGET(filterStatus);
      setEvents(data);
    } catch (err) {
      console.log(`Failed to fetch events: ${err.message}`);
    }
  };

  // Fetch events initially and when filterStatus changes
  useEffect(() => {
    fetchEvents();
  }, [filterStatus]);




  const handleView = async (eventId) => {
    try {
      const dataArray = await eventGET_ID(eventId);  // returns array
      const data = dataArray[0];                      // take the first object
      if (!data) return toast.error('Event not found');

      const [start_time, end_time] = data.time_range?.split('-') || ['09:00', '17:00'];
      setSelectedEvent({ ...data, start_time, end_time });
      setShowViewModal(true);


    } catch (err) {
      toast.error(`Failed to fetch event details: ${err.message}`);
    }
  };

  const handleJoinEvent = async () => {
    if (!selectedEvent?.id) return;

    try {
      if (isParticipant) {
        // Cancel participation
        await participantsDELETE(selectedEvent.id);
      } else {
        // Join event
        await participantsPOST({ event_id: selectedEvent.id });


      }

      setShowViewModal(false);

      fetchEvents(); // <--- trigger a refetch after join/cancel

    } catch (err) {
      const serverMessage = err.response?.data?.detail;
      alert('❌ Failed to  changes: ' + (serverMessage || err.message));
    }
  };

 const nowPH = new Date();


const todayDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(nowPH).replace(/\//g, '-');

const currentTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Manila',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).format(nowPH);



const handleTimeChange = (field, value) => {
  setSelectedEvent((prev) => {
    const updated = { ...prev, [field]: value };

    const isToday = updated.event_date === todayDate;

    if (field === 'start_time') {
      if (isToday && value < currentTime) {
        alert('Start time cannot be earlier than current time');
        return prev;
      }

      if (updated.end_time && value >= updated.end_time) {
        alert('Start time must be earlier than end time');
        return prev;
      }
    }

    if (field === 'end_time') {
      if (updated.start_time && value <= updated.start_time) {
        alert('End time must be later than start time');
        return prev;
      }
    }

    return updated;
  });
};
  return (


    <Container className="p-0">

      <Row className="align-items-center mb-2">
        <Col>
          <h6 style={{
            fontSize: '30px',
              fontWeight: '700',
              fontStyle: 'bolder',
              color: '#740A03',
              fontFamily: 'Arial, sans-serif'
           }}>DISCOVER EVENTS</h6>
        </Col>
        <Col xs="auto" className="position-relative">
          {/* Funnel icon triggers the select */}
          <i
            className="bi bi-funnel-fill"
            style={{ fontSize: '1.5rem', 
             color: '#b84a13', 
              
              cursor: 'pointer' }}
            onClick={() => document.getElementById('filterSelect').focus()}
          ></i>

          {/* Hidden select, shown on focus/dropdown */}
          <select
            id="filterSelect"
            className="form-select form-select-sm position-absolute top-0 start-0 opacity-0"
            value={filterStatus}
            onChange={e => setFilterStatus(e.target.value)}
            style={{ width: '2rem', height: '2rem' }} // small clickable area
          >
            <option value="all">All</option>
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
          </select>
        </Col>
      </Row>

      <div className="w-100" style={{ maxHeight: '200px' }}>
        {events.map((event) => (
          <Row
            key={event.id}
            className="align-items-center mb-2 p-2 border rounded"
            style={{ 
              background: '#b84a13' }}


          >
            <Col style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              <strong title={event.event_name}>{event.event_name}</strong>
            </Col>
            <Col xs="auto">
              <Button
                variant="info"
                size="sm"
                onClick={() => {
                  handleView(event.id);
                  setIsParticipant(event.is_participant);
                  setisApproved(event.status);
                  setIsOrganizer(event.is_organizer);

                }}
              >
                {event.is_organizer
                  ? 'Managed'
                  : event.status
                    ? event.status.charAt(0).toUpperCase() + event.status.slice(1) // optional: capitalize
                    : 'View'}
              </Button>
            </Col>
          </Row>
        ))}
      </div>



      {/* Modal: replaced layout-only (logic preserved) */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <div
          style={{
        //    backgroundColor: "#ff9500d8", // bright background
        //    color: "#fff", // white text
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Event Details</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="mb-3 g-3">
              {/* Event Name */}
              <Col xs={12} md={8} className="d-flex flex-column">
                <label className="form-label-sm mb-1">Event Name</label>
                <input
                  type="text"
                  name="event_name"
                  value={selectedEvent?.event_name || ''}
                  onChange={(e) =>
                    setSelectedEvent(prev => ({ ...(prev || {}), event_name: e.target.value }))
                  }
                  className="form-control"
                  style={{
                    width: '100%',
                    height: '60px',
                    fontSize: '1.2rem',
                    padding: '0.75rem',
                  }}
                  readOnly={!isOrganizer}
                />
              </Col>

              {/* Event Date */}
              <Col xs={12} md={4} className="d-flex flex-column">
                <label className="form-label-sm mb-1">Event Date</label>
                <DatePicker
                  selected={
                    selectedEvent?.event_date
                      ? new Date(selectedEvent.event_date)
                      : null
                  }
                  onChange={(date) =>
                    setSelectedEvent(prev => ({
                      ...(prev || {}),
                      event_date: date ? date.toISOString().split('T')[0] : null,
                    }))
                  }
                  dateFormat="yyyy-MM-dd"
                  minDate={new Date()}
                  required
                  customInput={
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        width: '100%',
                        height: '60px',
                        fontSize: '1.2rem',
                        padding: '0.75rem',
                      }}
                      readOnly={!isOrganizer}
                    />
                  }
                  disabled={!isOrganizer}
                />
              </Col>
            </Row>

            {selectedEvent && (
              <>

                <Row className="mb-2">
                  <Col xs="auto">
                    <label className="form-label form-label-sm me-1 mb-0">Start Time</label>
                    <input
                      className="form-control form-control-sm"
                      type="time"
                      name="start_time"
                      value={selectedEvent.start_time || ''}
                        onChange={(e) => handleTimeChange('start_time', e.target.value)}


                      style={{ width: '200px' }}
                      readOnly={!isOrganizer}
                      onClick={(e) => {
                        if (isOrganizer) e.currentTarget.showPicker?.();
                      }}
                      disabled
                    />
                  </Col>

                  <Col xs="auto">
                    <label className="form-label form-label-sm me-1 mb-0">End Time</label>
                    <input
                      className="form-control form-control-sm"
                      type="time"
                      name="end_time"
                      value={selectedEvent.end_time || ''}
                       onChange={(e) => handleTimeChange('end_time', e.target.value)}

                      style={{ width: '200px' }}
                      readOnly={!isOrganizer}
                      onClick={(e) => {
                        if (isOrganizer) e.currentTarget.showPicker?.();
                      }}
                      disabled
                    />
                  </Col>
                </Row>




                <div className="mb-3">
                  <textarea
                    className="form-control form-control-sm"
                    name="description"
                    value={selectedEvent.description || ''}
                    onChange={(e) =>
                      setSelectedEvent(prev => ({ ...(prev || {}), description: e.target.value }))
                    }
                    style={{ height: '150px' }}
                    readOnly={!isOrganizer}
                  />
                </div>

                <Row className="mb-3">
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Max Participants</label>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      name="max_participants"
                      value={selectedEvent.max_participants || ''}
                      onChange={(e) =>
                        setSelectedEvent(prev => ({ ...(prev || {}), max_participants: e.target.value }))
                      }
                      style={{ width: '150px' }}
                      readOnly={!isOrganizer}
                    />
                  </Col>
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Address</label>
                    <input
                      className="form-control form-control-sm"
                      name="address"
                      value={selectedEvent.address || ''}
                      onChange={(e) =>
                        setSelectedEvent(prev => ({ ...(prev || {}), address: e.target.value }))
                      }
                      style={{ width: '398px' }}
                      readOnly={!isOrganizer}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Venue</label>
                    <input
                      className="form-control form-control-sm"
                      name="venue"
                      value={selectedEvent.venue || ''}
                      onChange={(e) =>
                        setSelectedEvent(prev => ({ ...(prev || {}), venue: e.target.value }))
                      }
                      style={{ width: '400px' }}
                      readOnly={!isOrganizer}
                    />
                  </Col>

                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Permission</label>
                    <select
                      className="form-select form-select-sm"
                      name="permission"
                      value={selectedEvent.permission || 'none'}
                      onChange={(e) =>
                        setSelectedEvent(prev => ({ ...(prev || {}), permission: e.target.value }))
                      }
                      style={{ width: '200px' }}
                      disabled={!isOrganizer}
                    >
                      <option value="none">None</option>
                      <option value="need_permission">Need Permission</option>
                    </select>
                  </Col>
                </Row>

                <Table size="sm" bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedEvent.participants?.length > 0 ? (
                      selectedEvent.participants.map((p) => (
                        <tr key={p.participant_id || p.email}>
                          <td>{p.full_name}</td>
                          <td>{p.email}</td>
                          <td>
                            {isOrganizer ? (
                              <select
                                value={p.participant_status}
                                className="form-select form-select-sm"
                                onChange={async (e) => {
                                  const newStatus = e.target.value;
                                  const oldStatus = p.participant_status;

                                  // optimistic UI update
                                  setSelectedEvent(prev => ({
                                    ...prev,
                                    participants: prev.participants.map(part =>
                                      part.participant_id === p.participant_id
                                        ? { ...part, participant_status: newStatus }
                                        : part
                                    ),
                                  }));

                                  try {
                                    await participantsPATCH(p.participant_id, {
                                      event_id: selectedEvent.id,
                                      status: newStatus
                                    });
                                  } catch (err) {
                                    // revert
                                    setSelectedEvent(prev => ({
                                      ...prev,
                                      participants: prev.participants.map(part =>
                                        part.participant_id === p.participant_id
                                          ? { ...part, participant_status: oldStatus }
                                          : part
                                      ),
                                    }));
                                    alert(`Failed to update status: ${err.response?.data?.detail || err.message}`);
                                  }
                                }}
                              >
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                              </select>
                            ) : (
                              p.participant_status
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center text-muted">
                          No participants
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            {isOrganizer ? (
              <>
                <Button variant="danger" onClick={() => { /* layout-only delete placeholder */ }}>
                  Delete
                </Button>
                <Button
                  variant="primary"
                  onClick={async () => {
  const now = new Date();

  const eventDate = new Date(selectedEvent.event_date);

  const [sh, sm] = selectedEvent.start_time.split(":").map(Number);
  const [eh, em] = selectedEvent.end_time.split(":").map(Number);

  const start = new Date(eventDate);
  start.setHours(sh, sm, 0, 0);

  const end = new Date(eventDate);
  end.setHours(eh, em, 0, 0);

  if (start < now) {
    alert("Start time cannot be in the past");
    return;
  }

  if (end <= start) {
    alert("End time must be later than start time");
    return;
  }

  const payload = {
    ...selectedEvent,
    time_range: `${selectedEvent.start_time}-${selectedEvent.end_time}`,
  };

  try {
    await eventPATCH(payload);
    setShowViewModal(false);
    fetchEvents();
  } catch (err) {
    const message =
      err?.response?.data?.detail ||
      err?.message ||
      "Unknown error";

    alert(message);
  }
}}
                >
                  Save Changes
                </Button>
              </>
            ) : (
              <Button
                variant={isParticipant ? 'danger' : 'success'}
                onClick={handleJoinEvent}
                disabled={!isParticipant && selectedEvent?.status === 'full'}
              >
                {isParticipant
                  ? isApproved === "approved"
                    ? 'Leave event'
                    : 'Cancel approval'
                  : selectedEvent?.status === 'full'
                    ? 'Full'
                    : 'Join'}
              </Button>
            )}
          </Modal.Footer>
        </div>
      </Modal>


      <ToastContainer position="top-right" autoClose={5000} hideProgressBar newestOnTop closeOnClick draggable pauseOnHover />
    </Container >
  );
};

export default DiscoverEvents;
